<template>
  <div class="member-list">
    <vue-good-table
      v-if="isTeamOwner"
      :columns="adminColumns"
      :rows="members"
      styleClass="vgt-table striped"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 50,
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page',
        allLabel: 'All'
      }"
      @on-cell-click="onCellClick"
    >
      <div slot="emptystate">No users found!</div>
      <template slot="table-row" slot-scope="members">
        <div
          v-if="
            members.column.field === 'action' &&
              members.row.state !== 'pending' &&
              members.row.id === user.id
          "
          class="text-left member-role"
        >
          You
        </div>

        <!-- Remove column -->
        <div
          v-else-if="
            members.column.field === 'action' &&
              members.row.state !== 'pending' &&
              members.row.id !== user.id
          "
        >
          <label
            class="checkbox-container"
            v-if="includedToRemove(parseInt(members.row.id))"
          >
            <input type="checkbox" disabled checked />
            <span class="checkmark checkmark-center"></span>
          </label>
          <label class="checkbox-container" v-else>
            <input type="checkbox" disabled />
            <span class="checkmark checkmark-center"></span>
          </label>
        </div>

        <!-- user roles -->
        <div
          v-else-if="
            members.column.field === 'role' && members.row.state !== 'pending'
          "
        >
          <div v-if="members.row.id !== user.id">
            <select
              v-model="members.row.role"
              class="minimal"
              @change="changeUserRole($event, members.row.id)"
            >
              <option
                v-for="role in roles"
                v-bind:value="role.value"
                :key="role.value"
                >{{ role.text }}</option
              >
            </select>
          </div>
          <div v-else>
            <span class="member-role">{{ members.row.role }}</span>
          </div>
        </div>

        <!-- user team -->
        <div
          v-else-if="
            members.column.field === 'subteam' &&
              members.row.state !== 'pending'
          "
        >
          <div v-if="members.row.subteam && isTeamOwner">
            <select
              class="team"
              v-model="members.row.subteam.id"
              @change="changeUserTeam($event, members.row.id)"
            >
              <option
                v-for="team in teamsList"
                v-bind:value="team.id"
                :key="team.id"
                >{{ team.name }}</option
              >
              <option value="-1">None</option>
            </select>
          </div>
        </div>

        <!-- user name -->
        <div v-else-if="members.column.field === 'name'">
          <div v-if="members.row.state !== 'pending'">
            <span class="break-word">{{ members.row.name }}</span
            ><br />
            <span class="break-word">{{ members.row.email }}</span>
          </div>
          <div v-else>
            <span v-html="members.row.email"></span>
          </div>
        </div>

        <div
          v-else-if="
            members.column.field === 'budget' && members.row.state === 'pending'
          "
        >
          <div class="invite-actions">
            <button
              class="whitebutton-gemnote resend-invite-small remove-invite"
              @click="removeInvitation(members.row.token)"
            >
              <span>Remove Invitation</span>
            </button>

            <button
              class="button-gemnote button-gemnote--small resend-invite-small"
              @click="resendInvitation(members.row.token)"
            >
              <span>Resend Invitation</span>
            </button>
          </div>
        </div>
      </template>
    </vue-good-table>

    <!-- User Table State -->
    <vue-good-table
      v-if="!isTeamOwner"
      :columns="userColumns"
      :rows="members"
      styleClass="vgt-table striped"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
        skipDiacritics: true
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 50,
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page',
        allLabel: 'All'
      }"
      @on-cell-click="onCellClick"
    >
      <div slot="emptystate">No users found!</div>
      <template slot="table-row" slot-scope="members">
        <div
          v-if="
            members.column.field === 'action' &&
              members.row.state !== 'pending' &&
              members.row.id === user.id
          "
          class="text-center"
        >
          You
        </div>

        <div
          v-else-if="
            members.column.field === 'subteam' &&
              members.row.state !== 'pending'
          "
        >
          <span>{{ members.row.subteam ? members.row.subteam.name : '' }}</span>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'LiteUsersList',
  created() {
    this.$store.dispatch('globalTracking/changeSearchTerm', '')
  },
  data() {
    return {
      cellIndexClicked: new Array(this.members.length),
      roles: [
        { text: 'Admin', value: 'Admin' },
        { text: 'User', value: 'User' }
      ],
      adminColumns: [
        {
          label: '',
          field: 'action',
          sortable: false,
          width: '10%'
        },
        {
          label: 'Role',
          field: 'role',
          sortable: false,
          width: '10%'
        },
        {
          label: 'Team',
          field: 'subteam',
          sortable: false,
          width: '15%'
        },
        {
          label: 'Name',
          field: 'name',
          html: true,
          width: '25%'
        },
        {
          label: '',
          field: 'budget',
          sortable: false,
          width: '35%'
        }
      ],
      userColumns: [
        {
          label: '',
          field: 'action',
          sortable: false,
          width: '10%'
        },
        {
          label: 'Role',
          field: 'role',
          width: '10%'
        },
        {
          label: 'Full Name',
          field: 'name',
          width: '25%'
        },
        {
          label: 'Email',
          field: 'email',
          html: true,
          width: '30%'
        },
        {
          label: 'Team',
          field: 'subteam',
          sortable: false,
          width: '15%'
        },
        {
          label: '',
          field: 'budget',
          sortable: false,
          width: '10%'
        }
      ]
    }
  },
  props: {
    members: {
      type: Array,
      required: true
    },
    teamsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isTeamOwner() {
      return this.$store.getters['profile/isTeamOwner']
    },
    user() {
      return this.$store.getters['profile/user']
    },
    ...mapState({
      searchTerm: state => state.globalTracking.searchTerm,
      usersToRemove: state => state.team.usersToRemove
    })
  },
  components: {
    VueGoodTable
  },
  methods: {
    changeUserRole(event, userId) {
      let role = event.target.value === 'Admin' ? 'team_owner' : ''
      this.$store.dispatch('team/changeUserRole', { userId, role })
    },
    changeUserTeam(event, userId) {
      if (event.target.value == '-1') {
        // remove user from team
        this.$store.dispatch('subTeams/removeUserFromSubTeam', { userId })
      } else {
        // add user to new team
        this.$store.dispatch('subTeams/addUserToTeam', {
          userId,
          subTeamId: event.target.value
        })
      }
    },
    onCellClick({ column, row }) {
      // let index
      // params.row - row object
      // params.column - column object
      // params.rowIndex - index of this row on the current page.
      // params.event - click event

      switch (column.field) {
        case 'action':
          this.$store.dispatch('team/addUserListToRemove', {
            id: parseInt(row.id),
            name: row.name
          })
          break
      }
    },
    resendInvitation(token) {
      this.$store.dispatch('team/resendInvitation', token)
    },
    removeInvitation(token) {
      this.$store.dispatch('team/removeInvitation', token)
    },
    includedToRemove(id) {
      let index = this.usersToRemove.findIndex(user => user.id === id)

      if (index >= 0) {
        return true
      }

      return false
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../global.scss';

.member-list {
  padding-top: 2rem;

  h1 {
    text-align: left;
  }
}

select {
  margin: 0;
  font-family: $nunito;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  height: 2rem;
  border-radius: 0;
  font-size: 15px;
  display: inline-block;
  border: transparent;
  line-height: 1;
  color: $onyx;
  background-color: #f7f7f7;
  padding: 0em 0em 0.5em 0em;

  &:focus,
  &:hover {
    outline: 0;
    border-bottom: 0px;
    box-shadow: none;
  }
}

select.minimal {
  font-weight: normal;
  background-image: linear-gradient(45deg, transparent 50%, $onyx 50%),
    linear-gradient(135deg, $onyx 50%, transparent 50%);
  background-position: calc(100% - 10px) calc(1em + -5px),
    calc(100% - 5px) calc(1em + -5px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  width: 65px;
}

select.minimal:focus {
  background-image: linear-gradient(45deg, $onyx 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, $onyx 50%);
  background-position: calc(100% - 5px) 0.6em, calc(100% - 10px) 0.6em,
    calc(100% - 2.5em) 1em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  border-color: transparent;
  outline: 0;
}

select.team {
  font-weight: normal;
  background-image: linear-gradient(45deg, transparent 50%, $onyx 50%),
    linear-gradient(135deg, $onyx 50%, transparent 50%);
  background-position: calc(100% - 10px) calc(1em + -5px),
    calc(100% - 5px) calc(1em + -5px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}

select.team:focus {
  background-image: linear-gradient(45deg, $onyx 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, $onyx 50%);
  background-position: calc(100% - 5px) 0.6em, calc(100% - 10px) 0.6em,
    calc(100% - 2.5em) 1em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  border-color: transparent;
  outline: 0;
}

.member-role {
  padding: 0em 0em 0em 0em;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
}

.break-word {
  display: inline-block;
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link-text {
  text-decoration: underline;
  cursor: pointer;
}

.edit-budget {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  span:nth-child(1n) {
    flex-basis: 25%;
  }

  span:nth-child(2n) {
    flex-basis: 25%;
    text-decoration: underline;
    cursor: pointer;
  }

  button {
    flex-basis: 40%;
  }
}

.budget-group {
  margin: 0;
  align-items: center;
  display: flex;
  justify-content: space-between;

  form {
    flex-basis: 25%;

    input {
      padding: 0;
      text-align: center;
      height: 20px !important;
      padding: 9px 0px 9px 0px !important;
      width: 70px !important;
    }
  }

  .cancel-edition {
    flex-basis: 25%;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
  }

  button {
    flex-basis: 40%;
  }
}

.invite-actions {
  display: flex;
  gap: 1rem;

  .button-gemnote {
    &:hover {
      background-color: $onyx;
      opacity: 0.8;
    }
  }

  button.remove-invite {
    span.icon {
      margin-left: 5px;
      font-weight: normal;
    }
  }
}

.invite-actions > * {
  flex: 1 1 10rem;
}
</style>
